import * as ApiConfig from './apiConfig';
import { AppName } from '../enum/appConfig';
import md from '../winform/function/md';
import { CheckLibs } from './check';
function defaultEnv() {
    let env = '';
    if (window) {
        env = window.HZMD_ENV || '';
        !env && (window.localStorage.getItem(AppName.ENV));
    }
    // @ts-ignore
    if (CheckLibs.isUniApp()) {
        // @ts-ignore
        env = uni.getStorageSync(AppName.ENV);
    }
    return env || '';
}
export const ApiLibsFn = function (env = '') {
    !env && (env = defaultEnv());
    !env && (console.error('window.HZMD_ENV环境未配置'));
    if (!['development', 'test', 'production'].includes(env)) {
        console.error('env仅支持development,test,production');
    }
    const clientApiConfig = md.getApiConfig();
    return {
        /**
         * 主配链接口地址
         */
        ZPChainApi: clientApiConfig.ZPChainApi || ApiConfig.ZPChainApi[env],
        /**
         * 大工程师接口地址
         */
        EngineerApi: clientApiConfig.EngineerApi || ApiConfig.EngineerApi[env],
        /**
         * 今日制造api60接口地址
         */
        JrzzApi60: clientApiConfig.JrzzApi60 || ApiConfig.JrzzApi60[env],
        /**
         * 今日制造api4接口地址
         */
        JrzzApi40: clientApiConfig.JrzzApi40 || ApiConfig.JrzzApi40[env],
        /**
         * api80接口地址
         */
        JrzzApi80: clientApiConfig.JrzzApi80 || ApiConfig.JrzzApi80[env],
        /**
         * api81广告服务
         */
        Api81: clientApiConfig.Api81 || ApiConfig.Api81[env],
        /**
         * StdApi资源服务地址
         */
        StdApi: clientApiConfig.StdApi || ApiConfig.StdApi[env],
        /**
         * 济南图片资源服务地址1
         */
        JnImgHost: clientApiConfig.JnImgHost || ApiConfig.JnImgHost[env],
        /**
         * 济南图片资源服务地址2
         * 支持产品图、标准件分类icon、通用件分类icon
         */
        JnImageHost: clientApiConfig.JnImageHost || ApiConfig.JnImageHost[env],
        /**
         * 杭州今日制造oss资源地址
         */
        HzOssHost: clientApiConfig.HzOssHost || ApiConfig.HzOssHost[env],
        /**
         * 济南oss资源地址
         */
        JnOssHost: clientApiConfig.JnOssHost || ApiConfig.JnOssHost[env],
        /**
         * 济南oss资源查看地址
         * 仅查看的时候用到，用于资源访问加速
         */
        JnOssLook: clientApiConfig.JnOssLook || ApiConfig.JnOssLook[env],
    };
};
export const DomainLibsFn = function (env = '') {
    !env && (env = defaultEnv());
    !env && (console.error('window.HZMD_ENV环境未配置'));
    if (!['development', 'test', 'production'].includes(env)) {
        console.error('env仅支持development,test,production');
    }
    const clientApiConfig = md.getApiConfig();
    return {
        /**
         * 大工程师web服务地址
         */
        EngineerWeb: clientApiConfig.EngineerWeb || ApiConfig.EngineerWeb[env],
        /**
         * 聊天服务地址
         */
        ImWeb: clientApiConfig.ImWeb || ApiConfig.ImWeb[env],
        /**
         * 主配链web服务地址
         */
        ZPChainWeb: clientApiConfig.ZPChainWeb || ApiConfig.ZPChainWeb[env],
        /**
         * 主配链worker服务地址
         */
        ZPChainWorkerWeb: clientApiConfig.ZPChainWorkerWeb || ApiConfig.ZPChainWorkerWeb[env],
        /**
         * 客源宝体系项目公共页面地址
         */
        EngineerCommon: clientApiConfig.EngineerCommon || ApiConfig.EngineerCommon[env],
        /**
         * 企业选型服务地址
         */
        LectoWeb: ApiConfig.LectoWeb[env],
    };
};
